import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

// _customerId: a caller passes one, but this hook reads the id from the route; kept for call-site compat.
export const useCustomerRoles = (_customerId?: any) => {
  const customerId = useCustomerId()

  return useQuery({
    queryKey: ['customer', customerId, 'roles'],
    queryFn: () => get(`/customers/${customerId}/roles?`),
    initialData: [],
  })
}
